type EventHandler<T> = (e: T) => void;

export class EventBroker<T> {
	private handlers: EventHandler<T>[] = [];

	public add(handler: EventHandler<T>, once: boolean = false) {
		if (!once) {
			this.handlers.push(handler);
			return;
		}

		this.handlers.push((e) => {
			this.remove(handler);
			handler(e);
		});
	}

	public remove(handler: EventHandler<T>) {
		let index = this.handlers.indexOf(handler);
		if (index >= 0) {
			this.handlers.splice(index, 1);
		}
	}

	public invoke(event: T) {
		for (let handler of this.handlers) {
			handler(event);
		}
	}
}
